import { Countries } from '~/common/constants/countries.enum';

export function useCountrySelectData() {
  const isCanadaEnabled = true;
  const countrySelectData = [{ value: Countries.US, label: 'United States' }];

  if (isCanadaEnabled) {
    countrySelectData.push({ value: Countries.CA, label: 'Canada' });
  }

  return countrySelectData;
}
